export default class DtoUsersOfFilters {
    constructor(obj) {
        this.module = obj.module
        this.codeList = obj.codeList
        this.user = obj.user
        this.contributorCode = obj.contributorCode
        this.userProfil = obj.userProfil
    }
}
